import React from 'react'
import Modal from 'react-modal'
import styles from './attachmentDialog.scss'
import cs from 'classnames'
import nesProp from 'nested-property'
import { connect } from 'react-redux'
import { Table, Thead, Th, Tr, Td, collapseTd } from 'components/reactable'
import Uploader from '../uploader'
import i18n from 'lib/i18n'
import c from 'state/constants'

const _ = i18n('attachmentDialog')
const _uploaderTranslations = i18n('uploader')

const customStyles = {
    overlay: {
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        display: 'flex', justifyContent: 'center', alignItems: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.75)',
    },
    content: {
        position: 'relative',
        top: 'initial', bottom: 'initial', left: 'initial', right: 'initial',
        maxHeight: '90%', overflow: 'auto', padding: '0',
    },
}

/**
 * This module will handle oracle documents selection for both email attachments and dsWizard oracle documents selection
 */
@connect((state) => ({
    modalIsOpen: state.emailSender.emailAttModalIsOpen,
    attachmentModal: state.emailSender.attachmentModal,
    EmailTemplateRelations: state.app.security.EmailTemplateRelations,

}))
export default class AttachmentDialog extends React.Component {
    static propTypes = {
        onCancel: React.PropTypes.func,
        onConfirmation: React.PropTypes.func,
        cancelLabel: React.PropTypes.string,
        confirmationLabel: React.PropTypes.string,
        moduleOptions: React.PropTypes.any.isRequired,
        moduleKey: React.PropTypes.string,
        selected0: React.PropTypes.array,
        selected1: React.PropTypes.array,
        selected2: React.PropTypes.array,
        selected3: React.PropTypes.array,
        selected4: React.PropTypes.array,
        ticketDocuments: React.PropTypes.array,
    }

    /**
     * Constructor.
     * Here initialize the state values
     * @param {*} props
     */
    constructor(props) {
        super(props)

        const { moduleOptions, isDsWizard, ticketDocuments } = props
        let tabIndex = 0

        // decide the initial tabIndex after module key
        if (isDsWizard) {
            tabIndex = moduleOptions && moduleOptions.clientDocuments && moduleOptions.clientDocuments.length > 0 ? 2 :
                moduleOptions.claimDocuments && moduleOptions.claimDocuments.length > 0 ? 0 :
                    moduleOptions.contractDocuments && moduleOptions.contractDocuments.length > 0 ? 1 :
                        moduleOptions.tarificationDocuments && moduleOptions.tarificationDocuments.length > 0 ? 3 :
                            ticketDocuments && ticketDocuments.length > 0 ? 4 : 0

            // On modules mut selected the tab what have the specified documents
            // BEWB-723
            switch (props.moduleKey) {
                // universal module detection, (the module keys are uset to identify the react modules,
                // but the EmailTemplateModules have mroe values and differ. On initialistaion this module got,
                // the react module contans, but must work with other one, because the attachment
                // modal originally was made for emails attachment composition not for DSWizard!
                // So not was planed to be universal file selector over the hole project)
                case c.DS_MODULE_CLIENT_TARIFICATION:
                case props.EmailTemplateRelations.EmailTemplateModules.clientTarificationDetails.value: {
                    if (moduleOptions.tarificationId) {
                        tabIndex = 3
                    }
                    break
                }
                case c.DS_MODULE_CLIENT_PROFILE:
                case props.EmailTemplateRelations.EmailTemplateModules.clientsProfile.value: {
                    if (moduleOptions && moduleOptions.clientId) {
                        tabIndex = 2
                    }
                    break
                }
                case c.DS_MODULE_CLIENT_CONTRACT:
                case props.EmailTemplateRelations.EmailTemplateModules.clientsDetailsContract.value: {
                    if (moduleOptions.contractId) {
                    tabIndex = 1
                    }
                    break
                }
                case c.DS_MODULE_CLIENT_CLAIMS:
                case props.EmailTemplateRelations.EmailTemplateModules.claims.value:
                case props.EmailTemplateRelations.EmailTemplateModules.clientsClaimsDetail.value: {
                    if (moduleOptions.claimId) {
                        tabIndex = 0
                    }
                    break
                }
                case props.EmailTemplateRelations.EmailTemplateModules.inboxReplyToWillemot.value: {
                    if (ticketDocuments && ticketDocuments.length > 0) {
                        tabIndex = 4
                    }
                }
            }
        } else {
            switch (props.moduleKey) {
                case props.EmailTemplateRelations.EmailTemplateModules.clientTarificationDetails.value: {
                    tabIndex = 3
                    break
                }
                case props.EmailTemplateRelations.EmailTemplateModules.clientsProfile.value: {
                    tabIndex = 2
                    break
                }
                case props.EmailTemplateRelations.EmailTemplateModules.clientsDetailsContract.value: {
                    tabIndex = 1
                    break
                }
                case props.EmailTemplateRelations.EmailTemplateModules.clientsClaimsDetail.value: {
                    tabIndex = 0
                    break
                }
                case props.EmailTemplateRelations.EmailTemplateModules.claims.value: {
                    tabIndex = 0
                    break
                }
                case props.EmailTemplateRelations.EmailTemplateModules.inboxReplyToWillemot.value: {
                    tabIndex = 4
                    break
                }
            }
        }

        this.state = { selected0: [], selected1: [], selected2: [], selected3: [], selected4: [], tabIndex: tabIndex }
    }

    /**
     * This function triggered when the component receive props
     * @param {*} nextProps
     * @param {*} props
     */
    componentWillReceiveProps(nextProps, props) {
        // update "selected0" in state when receive new props
        if (JSON.stringify(nextProps.selected0) != JSON.stringify(this.state.selected0)) {
            this.setState({ selected0: nextProps.selected0 })
        }

        // update "selected1" in state when receive new props
        if (JSON.stringify(nextProps.selected1) != JSON.stringify(this.state.selected1)) {
            this.setState({ selected1: nextProps.selected1 })
        }

        // update "selected2" in state when receive new props
        if (JSON.stringify(nextProps.selected2) != JSON.stringify(this.state.selected2)) {
            this.setState({ selected2: nextProps.selected2 })
        }

        // update "selected3" in state when receive new props
        if (JSON.stringify(nextProps.selected3) != JSON.stringify(this.state.selected3)) {
            this.setState({ selected3: nextProps.selected3 })
        }

        // update "selected4" in state when receive new props
        if (JSON.stringify(nextProps.selected4) != JSON.stringify(this.state.selected4)) {

            // check if the value can be destructured, so that is an array no undefined
            let selected4 = []
            if (nextProps.selected4 && nextProps.selected4.length > 0) {
                selected4 = [...nextProps.selected4]
            }

            this.setState({ selected4 })
        }

        // update "selected4" in state when receive new props
        // if (JSON.stringify(nextProps.moduleOptions) !== JSON.stringify(this.props.moduleOptions)) {
        //     console.log("ATT DIALOG nextProps.moduleOptions", nextProps.moduleOptions )
        // }

    }

    /**
     * This function render the default document selector (uploader) for email sender
     */
    renderClaimsUploader() {
        const { selected0, moduleOptions } = this.props
        return (
            <Uploader
                type={moduleOptions.claimDocumentsType}
                documents={moduleOptions.claimDocuments}
                id={moduleOptions.claimDocumentsId}
                selectable={true}
                selected={selected0}
                selectedUpdaterCallback={(result) => {
                    this.setState({ selected0: result })
                }}
            />
        )
    }

    /**
     * This function render the default document selector (uploader) for email sender
     */
    renderContractUploader() {
        const { selected1, moduleOptions } = this.props
        return (
            <Uploader
                type={moduleOptions.contractDocumentsType}
                documents={moduleOptions.contractDocuments}
                id={moduleOptions.contractDocumentsId}
                selectable={true}
                selected={selected1}
                selectedUpdaterCallback={(result) => {
                    this.setState({ selected1: result })
                }}
            />
        )
    }

    /**
     * This function render the secondary document selector (client document) for email sender
     */
    renderClientUploader() {
        const { selected2, moduleOptions } = this.props

        return (
            <Uploader
                type={moduleOptions.clientDocumentsType}
                documents={moduleOptions.clientDocuments}
                id={moduleOptions.clientDocumentsId}
                selectable={true}
                selected={selected2}
                selectedUpdaterCallback={(result) => {
                    this.setState({ selected2: result })
                }}
            />
        )
    }

    /**
     * This function render the default document selector (uploader) for email sender
     */
    renderTarificationUploader() {
        const { selected3, moduleOptions } = this.props
        return (
            <Uploader
                type={moduleOptions.tarificationDocumentsType}
                documents={moduleOptions.tarificationDocuments}
                id={moduleOptions.tarificationDocumentsId}
                selectable={true}
                selected={selected3}
                selectedUpdaterCallback={(result) => {
                    this.setState({ selected3: result })
                }}
            />
        )
    }

    /**
    * This function render the default document selector (uploader) for dsWizard when opened from inbox
    */
    renderTicketUploader() {
        const { ticketDocuments } = this.props
        const { selected4 } = this.state
        return (
            <div className={styles.content}>
                <Table
                    filterable={[
                        "documentName"
                    ]}
                    ref={el => { this.table = el }}
                    id="table"
                    className="table"
                    sortable={[
                        'documentName',
                    ]}
                    defaultSort={{
                        column: 'documentName',
                        direction: 'desc',
                    }}

                    itemsPerPage={40}
                    pageButtonLimit={5}
                >
                    <Thead>
                        <Th column="documentMetaCol" label="" />
                        <Th column="signCheckbox">
                            <strong>{_("addToSignLabel")}</strong>
                        </Th>
                        {/* <Th column="attachmentCheckbox">
                            <strong>{_("addToEmailAttachment")}</strong>
                        </Th> */}
                        <Th column="documentName">
                            <strong>{_("documentName")}</strong>
                        </Th>
                    </Thead>
                    {ticketDocuments && ticketDocuments.length && ticketDocuments.length > 0 ?
                        ticketDocuments.map((item, key) =>
                            <Tr
                                className={`clickable`}
                                i={item}
                                key={key}
                            >
                                <Td column="documentMetaCol" className={styles.rowIcon}>
                                    <div>
                                        <div><img src={require('resources/images/pdf-icon_1x.png')} /></div>
                                    </div>
                                </Td>
                                <Td column="signCheckbox" >
                                    <div style={{ width: 15 }}>
                                        <input
                                            type="checkbox"
                                            onClick={ev => ev.stopPropagation()}
                                            onChange={ev => this.onSelectedForSigningCheckChange(ev, item)}
                                            checked={this.state.selected4 && this.state.selected4.findIndex(oneSelectedDoc => oneSelectedDoc.oracleDocumentId === item.oracleDocumentId) > -1 ? true : false}
                                        />
                                    </div>
                                </Td>
                                <Td column="documentName" value={item}>
                                    {JSON.stringify(this.state.selected4)}
                                    {item.oracleDocumentId}
                                </Td>
                            </Tr>
                        ) : ''
                    }
                </Table>
            </div>
        )
    }

    /**
    * Handle Ui event for individual checkbox for signing documents
    * @param {*} ev
    * @param {*} document
    */
    onSelectedForSigningCheckChange(ev, document) {
        const { selected4 } = this.state

        const index = selected4.findIndex(oneDoc => oneDoc.oracleDocumentId === document.oracleDocumentId)
        if (index >= 0) {
            selected4.splice(index, 1)
        } else {
            selected4.push(document)
        }
        this.setState({ selected4 })
    }

    /**
     * This is a container for primary document selector to show additional message
     */
    renderClientUploaderContainer() {
        const { attachmentModal } = this.props
        return (
            <div className={styles.content} key={"clientDocumentsContainer"}>
                {attachmentModal && attachmentModal.message}
                {this.renderClientUploader()}
            </div>
        )
    }

    /**
     * This will return with the correct title for the tab what describe the type of documents.
     */
    renderTitleForPrimaryTab(type) {
        return (type == 'client' && _uploaderTranslations('clientDocuments') ||
            type == 'claim' && _uploaderTranslations('claimDocuments') ||
            type == 'contract' && _uploaderTranslations('contractDocuments') ||
            type == 'tarification' && _uploaderTranslations('tarificationDocumentsTabTitle') ||
            type == 'ticketDocuments' && _uploaderTranslations('ticketDocuments') ||
            _('documents'))
    }

    /**
     * This function render the tabbed container for more list of documents.
     */
    renderTabbedUploaderContainer() {
        const { attachmentModal, moduleOptions, EmailTemplateRelations, moduleKey, isDsWizard, ticketDocuments } = this.props
        let { tabIndex } = this.state

        let isInboxReplyToWillemot = moduleKey == EmailTemplateRelations.EmailTemplateModules.inboxReplyToWillemot.value

        let isClient =
            moduleKey == EmailTemplateRelations.EmailTemplateModules.clientsProfile.value ||
                ((isInboxReplyToWillemot || isDsWizard) && moduleOptions && moduleOptions.clientDocuments && moduleOptions.clientDocuments.length > 0) ? true : false
        let isClientClaim =
            moduleKey == EmailTemplateRelations.EmailTemplateModules.clientsClaimsDetail.value ||
                ((isInboxReplyToWillemot || isDsWizard) && moduleOptions && moduleOptions.claimId) ? true : false
        let isClientContract =
            moduleKey == EmailTemplateRelations.EmailTemplateModules.clientsDetailsContract.value ||
                ((isInboxReplyToWillemot || isDsWizard) && moduleOptions && moduleOptions.contractId) ? true : false
        let isClaims =
            moduleKey == EmailTemplateRelations.EmailTemplateModules.claims.value
        let isTarification =
            moduleKey == EmailTemplateRelations.EmailTemplateModules.clientTarificationDetails.value || isInboxReplyToWillemot ||
                ((isInboxReplyToWillemot || isDsWizard) && moduleOptions && moduleOptions.tarificationId) ? true : false
        let hasTicketDocuments =
            (isDsWizard || isInboxReplyToWillemot) && ticketDocuments && ticketDocuments.length > 0

        return (
            <div className={styles.content} key={"documentsContainer"}>
                <br />
                {attachmentModal && attachmentModal.message}
                <div className={styles.TabContainer}>
                    {isClientClaim || isClaims ?
                        <div className={cs(styles.Tab, tabIndex == 0 ? styles.active : "")}
                            key="tab1"
                            onClick={() => { this.onTabSelect(0) }}>
                            {this.renderTitleForPrimaryTab('claim')}
                        </div>
                        : null}
                    {isClientClaim || isClientContract || isClaims ?
                        <div className={cs(styles.Tab, tabIndex == 1 ? styles.active : "")}
                            key="tab2"
                            onClick={() => { this.onTabSelect(1) }}>
                            {this.renderTitleForPrimaryTab('contract')}
                        </div>
                        : null}
                    {isClientClaim || isClientContract || isClient || isClaims || isTarification ?
                        <div className={cs(styles.Tab, tabIndex == 2 ? styles.active : "")}
                            key="tab3"
                            onClick={() => { this.onTabSelect(2) }}>
                            {this.renderTitleForPrimaryTab('client')}
                        </div>
                        : null}
                    {(isDsWizard && isTarification) || (!isDsWizard && (isTarification || isClient)) ?
                        <div className={cs(styles.Tab, tabIndex == 3 ? styles.active : "")}
                            key="tab4"
                            onClick={() => { this.onTabSelect(3) }}>
                            {this.renderTitleForPrimaryTab('tarification')}
                        </div>
                        : null}
                    {hasTicketDocuments ?
                        <div className={cs(styles.Tab, tabIndex == 4 ? styles.active : "")}
                            key="tab5"
                            onClick={() => { this.onTabSelect(4) }}>
                            {this.renderTitleForPrimaryTab('ticketDocuments')}
                        </div>
                        : null}
                </div>
                <div className={styles.TabContentContainer}>

                    {isClientClaim || isClaims ?
                        <div className={cs(styles.tabContent, tabIndex == 0 ? "" : styles.hidden)} key="tabContent1">
                            {this.renderClaimsUploader()}
                        </div>
                        : null}

                    {isClientClaim || isClientContract || isClaims ?
                        <div className={cs(styles.tabContent, tabIndex == 1 ? "" : styles.hidden)} key="tabContent2">
                            {this.renderContractUploader()}
                        </div>
                        : null}

                    {isClientClaim || isClientContract || isClient || isClaims || isTarification ?
                        <div className={cs(styles.tabContent, tabIndex == 2 ? "" : styles.hidden)} key="tabContent3">
                            {this.renderClientUploader()}
                        </div>
                        : null}

                    {(isDsWizard && isTarification) || (!isDsWizard && (isTarification || isClient)) ?
                        <div className={cs(styles.tabContent, tabIndex == 3 ? "" : styles.hidden)} key="tabContent4">
                            {this.renderTarificationUploader()}
                        </div>
                        : null}

                    {hasTicketDocuments ?
                        <div className={cs(styles.tabContent, tabIndex == 4 ? "" : styles.hidden)} key="tabContent5">
                            {this.renderTicketUploader()}
                        </div>
                        : null}
                </div>
            </div>
        )
    }

    /**
     * Event for selecting tab
     * @param {integer} index
     */
    onTabSelect(index) {
        this.setState({ tabIndex: index })
    }

    /**
     * Render attachment selector.
     * Render 2 tab for separated attachments possibilities
     */
    renderAttachmentSelector() {
        const { moduleOptions, moduleKey, EmailTemplateRelations, isDsWizard } = this.props
        // Always show each tab, but not on client module!
        let isThisTheClientModule =
            moduleKey == EmailTemplateRelations.EmailTemplateModules.clientsProfile.value

        return (
            isThisTheClientModule ?
                this.renderClientUploaderContainer() :
                this.renderTabbedUploaderContainer()
        )
    }

    /**
     * Main render function of this module
     */
    render() {
        const { modalIsOpen, attachmentModal, onCancel, onConfirmation, cancelLabel,
            confirmationLabel } = this.props
        return (
            <div>
                <Modal
                    isOpen={modalIsOpen}
                    onCancel={onCancel}
                    style={customStyles}
                    className={styles.modal}
                    contentLabel={""}
                >
                    <div>
                        <div className={styles.title}>{attachmentModal && attachmentModal.title}</div>
                        <div className={styles.contentWrapper}>
                            {this.renderAttachmentSelector()}
                            <div className={styles.buttons}>
                                <div
                                    onClick={onCancel}
                                    className={cs(styles.next, styles.enabled, styles.gray)}
                                >
                                    {cancelLabel}
                                </div>
                                <div
                                    onClick={(e) => {
                                        onConfirmation(this.state.selected0, this.state.selected1, this.state.selected2,
                                            this.state.selected3, this.state.selected4)
                                    }}
                                    className={cs(styles.next, styles.enabled)}
                                >
                                    {confirmationLabel}
                                </div>
                            </div>
                        </div>
                    </div>

                </Modal>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./components/emailSender/attachmentDialog.jsx